import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Service Workerのキャッシュのみをクリアする関数（ユーザーデータは保持）
const clearServiceWorkerCache = async () => {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
    }
  }
  // アプリキャッシュのみ削除（reminder-settingsキャッシュはユーザーデータを含まないため削除対象外）
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    for (const cacheName of cacheNames) {
      // ユーザーの習慣データ・記録データはIndexedDBに保存されているため、
      // キャッシュの削除はサービスワーカーの再取得に影響するだけで安全
      await caches.delete(cacheName);
    }
  }
};

// URLパラメータで強制リセットを確認（SWキャッシュのみクリア、ユーザーデータは保持）
if (window.location.search.includes('reset=true')) {
  clearServiceWorkerCache().then(() => {
    // localStorage.clear() は削除: ユーザーデータ（習慣・記録）が消えるため危険
    // IndexedDBのデータはそのまま保持する
    window.location.href = window.location.origin;
  });
}

// ルート要素の取得とエラーハンドリング
const rootElement = document.getElementById('root');

if (!rootElement) {
  // root要素が見つからない場合のフォールバック
  document.body.innerHTML = `
    <div style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      padding: 20px;
      text-align: center;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    ">
      <h1 style="color: #ff4757;">エラー</h1>
      <p style="color: #666;">アプリケーションの初期化に失敗しました。ページを再読み込みしてください。</p>
      <button onclick="location.reload()" style="
        margin-top: 20px;
        padding: 12px 24px;
        background-color: #667eea;
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 16px;
        cursor: pointer;
      ">再読み込み</button>
    </div>
  `;
} else {
  try {
    const root = ReactDOM.createRoot(rootElement);
    
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
    // Register as PWA
    serviceWorkerRegistration.register();
    
    // 10秒後にまだ読み込み中の場合は警告を表示
    setTimeout(() => {
      if (rootElement.innerHTML === '' || rootElement.textContent === '読み込み中...') {
        console.warn('App is taking longer than expected to load');
      }
    }, 10000);
    
  } catch (error) {
    console.error('Failed to render app:', error);
    rootElement.innerHTML = `
      <div style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        padding: 20px;
        text-align: center;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      ">
        <h1 style="color: #ff4757;">初期化エラー</h1>
        <p style="color: #666;">アプリケーションの起動に失敗しました。</p>
        <button onclick="location.reload()" style="
          margin-top: 20px;
          padding: 12px 24px;
          background-color: #667eea;
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 16px;
          cursor: pointer;
        ">再読み込み</button>
        <button onclick="if(confirm('すべての習慣データと記録が削除されます。\\nこの操作は取り消せません。\\n\\n本当に削除しますか？')) { indexedDB.deleteDatabase('HabitTrackerDB'); localStorage.clear(); sessionStorage.clear(); location.reload(); }" style="
          margin-top: 10px;
          padding: 12px 24px;
          background-color: #ff4757;
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 14px;
          cursor: pointer;
        ">データをクリアして再起動</button>
      </div>
    `;
  }
}